import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Message } from 'mage-i18n';
import { Badge } from '@klarna/bubble-ui';

import { getUserMerchantId } from '../selectors/merchant';

const MidIndicator = ({ merchantId }) =>
  merchantId ? (
    <Badge
      backgroundColorToken="colors/backgrounds/subtle-inline"
      borderColorToken="colors/backgrounds/subtle-inline"
      textColorToken="colors/text/default"
    >
      <Message
        path="products-fe.components.steps_headers.merchant.merchant_id"
        params={{ merchantId }}
      />
    </Badge>
  ) : null;

MidIndicator.propTypes = {
  merchantId: PropTypes.string,
};

export default connect(state => ({
  merchantId: getUserMerchantId(state),
}))(MidIndicator);
